import React, { useRef, useCallback, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import CanvasDraw from "react-canvas-draw";
// import CanvasDraw from "../../../../../../../utils/test/index";
// import { iOSDotEvent } from "../../../../../../../utils/canvasDrawUtil";

import ClearButton from "./ClearButton";
import {
  setIsOverRemoveStrokeAction,
  setIsOverStrokeAction,
  setNotepadAction
} from "../../../../../../../redux/answeringQuestions/notepad";
import EraserButton from "./EraserButton";
import UndoButton from "./UndoButton";
import Portrait from "../calculationKeypad/Portrait";
import {TYPE} from "../../../../../../../constant";
import {useTranslation} from "react-i18next";

const Notepad = ( props ) => {

  const canvasDraw = useRef();

  const notepad = useSelector( state => state.notepad );
  const keypad = useSelector( state => state.keypad );

  const dispatch = useDispatch();
  const setRemoveStroke = () => {dispatch(setIsOverRemoveStrokeAction())};
  const setNotepad = useCallback( payload => { dispatch( setNotepadAction( payload ) ) }, [ dispatch ] );
  const { t } = useTranslation();
  // useEffect(() => {
  //   if (canvasDraw) {
  //     iOSDotEvent(canvasDraw.current, 'mid_area');
  //   } 
  // }, [canvasDraw]);

  useEffect( () => {
    setNotepad( { canvasDraw : canvasDraw.current } );
  }, []);

  const handlePopupClose = () => {
    setRemoveStroke();
  }

  const {
    children,
    ...PROPS
  } = props;

  return (
    <div className="keypadBox active">
      <div className="keypad_wrap">
        <div className="keypad_gm notes">
          <div className="mid_area" id="mid_area">
            <div className="notes_cont" onTouchStart={ props.onShowClearButton }>
              <CanvasDraw
                ref={ canvasDraw }
                canvasWidth="100%"
                canvasHeight="100%"
                backgroundColor="rgba( 0, 0, 0, 0 )"
                hideGrid={ true }
                hideInterface={ true }
                lazyRadius={ 0 }
                brushRadius={ 3 }
                loadTimeOffset={2}
                onChange={ props.onNotes }
                disabled={notepad.isOverStrokeDisabled || notepad.isErase}
              />
            </div>
          </div>
          <div className="lower_area">{ children }</div>
            { notepad.isShowClearButton && (
              <div className="btn_wrap">
                <div className="pos_lft" style={{zIndex: 16}}>
                  {notepad.isOverStroke &&
                      <div className={`over_stroke_message ${keypad.orientation === TYPE.ORIENTATION.LANDSCAPE ? 'landscape_message' : ''}`}>
                        <div style={{ position: 'relative'}}>
                          <span className="close" onClick={handlePopupClose}/>
                          <div dangerouslySetInnerHTML={{ __html: t( 'LC_05_20.msg025' )}} />
                        </div>
                      </div>
                  }
                  <ClearButton {...PROPS}/>
                  <UndoButton {...PROPS} />
                  {/* <button className="bg_wht grn del on"></button> */}
                  {/* <button className="bg_wht grn prev off"></button> */}
                  {/* <button className="bg_wht grn next off"></button> */}
                </div>
                <EraserButton 
                  {...PROPS}
                />
              </div>
            )}
        </div>
      </div>
    </div>
  );

};

export default Notepad;
